import { Line } from '../../../types';

export class LayerEventManager {
  constructor(private onUpdate: (line: Line) => void) {}

  public updateLine(line: Line) {
    this.onUpdate(line);
  }
}